import React from 'react';
import { Section as SectionObject } from '../../../commons/components/faq/faqObjects';
import { useFAQContext } from '../../../commons/components/faq/FAQProvider';
import { RollableWrapper } from '../../../commons/components/faq/RollableWrapper';
import Question from './Question';
import HeaderWrapper from './HeaderWrapper';

interface Props {
  section: SectionObject;
}

const Section = ({ section }: Props) => {
  const { id, expanded, header, questions } = section;
  const { toggleSection } = useFAQContext();

  return (
    <>
      <HeaderWrapper id={id} expanded={expanded} header={header} toggleAction={toggleSection} />
      <RollableWrapper expanded={expanded}>
        {questions.map((question, index) => {
          return <Question key={index} question={question} />;
        })}
      </RollableWrapper>
    </>
  );
};

export default Section;
